<template>
<div
    class="create-button"
    :class="{'is-disabled': isDisabled}"
    :title="title"
    @click="clickHandler"
>
    <i
        class="fa fa-spinner fa-spin fa-2x is-disabled"
        v-if="isInProgress"
    ></i>
    <svg v-else>
        <use xlink:href="#icon-plus"></use>
    </svg>
</div>
</template>

<script>
export default {
    name: "CreateButton",
    props: {
        isDisabled: false,
        isInProgress: false,
        title: String,
        clickHandler: Function,
    }
}
</script>

<style scoped lang="scss">
@import 'resources/sass/variables';
.create-button {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $tests-grey;
    cursor: pointer;
    border: 1px solid #DEDEDE;
    border-radius: 6px;

    &:hover {
        & * {
            color: $tests-blue;
            fill: $tests-blue;
        }
    }

    svg {
        width: 34px;
        height: 34px;
        fill: $tests-grey;
    }

    &.is-disabled {
        opacity: 0.6;
        border-color: $grey;
        color: $grey;

        * {
            color: $grey;
            fill: $grey;
        }

        &:hover {
            cursor: not-allowed;
            opacity: 0.6;
            border-color: $grey;
            color: $grey;

            * {
                color: $grey;
                fill: $grey;
            }
        }
    }
}
</style>
